export default "__VITE_ASSET__BLPPsmDK__"